import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { BooleanField } from "../ConfigFields/BooleanField";
import { ColorsConstants } from "../../../../cssUtils/constants";
import { EnumField } from "../ConfigFields/EnumField";
import { formatTitle } from "../utils";

const DAY_DELTA_MIN = 0;
const DAY_DELTA_MAX = 5;

const CompareDateOfBirthPreset = ({
  schema,
  config,
  handleConfigChange,
  tags,
}) => {
  const day_delta_values = Array.from(
    { length: DAY_DELTA_MAX - DAY_DELTA_MIN + 1 },
    (_, i) => DAY_DELTA_MIN + i,
  );

  const getDayDeltaLabel = (dayDelta) => {
    if (dayDelta === 0) {
      return "Today";
    } else if (dayDelta === 1) {
      return "Tomorrow";
    } else {
      return `${dayDelta} days from today`;
    }
  }

  return (
    <Stack spacing={3}>
      <BooleanField
        fieldKey={"enable_tag_mode"}
        schema={schema?.properties["enable_tag_mode"] || {}}
        value={config["enable_tag_mode"]}
        required={false}
        onChange={(val) => handleConfigChange("enable_tag_mode", val)}
      />

      {config["enable_tag_mode"] && (
        <Autocomplete
          options={tags || []}
          value={tags?.filter((tag) => config["tags"]?.includes(tag.id)) || ""}
          multiple
          onChange={(e, newValue) =>
            handleConfigChange(
              "tags",
              newValue.map((tag) => tag.id),
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Tag"
              variant="outlined"
              required={config["enable_tag_mode"]}
            />
          )}
          getOptionLabel={(option) => option?.name || ""}
          renderOption={(props, option) => (
            <Stack
              {...props}
              key={option?.id}
              direction="column"
              gap={0.5}
              sx={{
                alignItems: "flex-start !important",
                textAlign: "left",
                width: "100%",
              }}
            >
              <Typography>{option?.name}</Typography>
            </Stack>
          )}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          noOptionsText="No Tags found"
        />
      )}

      <Autocomplete
        options={day_delta_values || []}
        value={config["day_delta"] || 0}
        multiple={false}
        onChange={(e, newValue) => handleConfigChange("day_delta", newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Compare Date"
            variant="outlined"
            required={true}
            size="small"
            helperText="The date to compare the user's date of birth against. (Today = Day of execution)"
            required
          />
        )}
        getOptionLabel={(option) => getDayDeltaLabel(option)}
        renderOption={(props, option) => (
          <Stack
            {...props}
            key={option?.id}
            direction="column"
            gap={0.5}
            sx={{
              alignItems: "flex-start !important",
              textAlign: "left",
              width: "100%",
            }}
          >
            <Typography>{getDayDeltaLabel(option)}</Typography>
          </Stack>
        )}
        isOptionEqualToValue={(option, value) => option === value}
        noOptionsText="No day delta found"
      />
    </Stack>
  );
};

export default CompareDateOfBirthPreset;
